import { splitArrayEvenly } from '@Components/Utilities/ArrayHelpers';
import { getBannerAd, insertURLParameter } from '@Components/Utilities/SandhillsUtility';
import { bannerAdPositions } from '@Components/Utilities/SandhillsConstants';
import Paging from '@Components/MuiWrappers/Paging';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import DoubleClickAd from '@Components/Shared/DoubleClick/DoubleClickAd';

const PartsManufacturerDrilldownView = (props) => {

    const {
        BreadCrumbs,
        DoubleClickAdCollection,
        ManufactuerUrls,
        Page,
        PageCount,
        SearchTitle,
        ViewAllManufacturer,
    } = props;

    const topBannerAd = getBannerAd(DoubleClickAdCollection?.AdUnits, bannerAdPositions.Top);

    const pageChange = (page) => {
        window.location = insertURLParameter(window.location.href, 'page', page);
    };

    return (
        <div id='parts-list-content' className='parts-list-content'>
            <section className='list-top-section'>
                <div className='parts-title-and-breadcrumbs'>
                    <ComplexBreadcrumb BreadCrumbModels={BreadCrumbs} />
                    <h1 className='parts-title'>
                        <span className='parts-title-text'><span dangerouslySetInnerHTML={{ __html: SearchTitle }}></span></span>
                    </h1>
                </div>
                {topBannerAd &&
                    <DoubleClickAd
                        {...DoubleClickAdCollection}
                        position={bannerAdPositions.Top}
                        ad={topBannerAd}
                        contained
                    />}
            </section>
            <section className='bottom-section'>
                <div className='parts-list-view'>
                    {ManufactuerUrls.length > 0 &&
                        <div className='top-manufacturers drilldown-section'>
                            <div className='content'>
                            {ViewAllManufacturer &&
                                <div className='parts-all'>
                                    <a href={ViewAllManufacturer.Url}>{ViewAllManufacturer.DisplayText}</a>
                                </div>}
                                <div className='section-container'>
                                    <div className='sub-section-container'>
                                        <div className='sub-section-content cf'>
                                        {splitArrayEvenly(ManufactuerUrls, 4).map((group, index) =>
                                            <div key={index} className='links'>
                                                {group.map((link) => 
                                                    <div key={link.DisplayText} className='links-container'>
                                                        <a href={link.Url} className='links-link'>{link.DisplayText}</a>
                                                    </div>)}
                                            </div>)}
                                        </div>
                                    </div>
                                </div>
                                {PageCount > 1 &&
                                    <Paging
                                        currentPage={Page}
                                        totalPages={PageCount}
                                        onChange={pageChange}
                                    />}
                            </div>
                        </div>}
                </div>              
            </section>
        </div>
    );
}

export default PartsManufacturerDrilldownView;
global.PartsManufacturerDrilldownView = PartsManufacturerDrilldownView;